const RYDER_LOAD_ID_PATTERN = /\b\d{8,9}\b/g;

// Trucker Tools accepts Ryder load IDs of 8 or 9 digits.
export function normalizeTruckerToolsLoadId(raw: string): string {
  const matches = raw.trim().match(RYDER_LOAD_ID_PATTERN) ?? [];
  const uniqueLoadIds = new Set(matches);

  if (uniqueLoadIds.size !== 1) {
    return '';
  }

  return uniqueLoadIds.values().next().value ?? '';
}
